module.exports = __webpack_public_path__ + "img/3.e93b9a79.png";